(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    const initializePreorderConfirmation = (root) => {
    root
      .querySelectorAll(
        'form[data-type="add-to-cart-form"], product-form form'
      )
      .forEach((form) => {
        const confirmation = form.querySelector(
          '[data-preorder-confirmation]'
        );

        if (
          !confirmation ||
          form.dataset.preorderInitialized === 'true'
        ) {
          return;
        }

        form.dataset.preorderInitialized = 'true';

        const checkbox = confirmation.querySelector(
          '[data-preorder-checkbox]'
        );

        const submitButton = form.querySelector(
          'button[type="submit"]'
        );

        const variantInput = form.querySelector(
          'input[name="id"]'
        );

        const variantsData = form.querySelector(
          '[data-preorder-variants]'
        );

        if (
          !checkbox ||
          !submitButton ||
          !variantInput ||
          !variantsData
        ) {
          return;
        }

        const variants = JSON.parse(variantsData.textContent);

        const synchronizeButton = () => {
          const variantIsAvailable =
            variants[String(variantInput.value)] === true;

          submitButton.disabled =
            !checkbox.checked || !variantIsAvailable;
        };

        checkbox.addEventListener(
          'change',
          synchronizeButton
        );

        form.addEventListener('change', () => {
          requestAnimationFrame(synchronizeButton);
        });

        new MutationObserver(synchronizeButton).observe(
          variantInput,
          {
            attributes: true,
            attributeFilter: ['value']
          }
        );

        synchronizeButton();
      });
  };

  initializePreorderConfirmation(document);

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializePreorderConfirmation(event.target);
    }
  );
  } catch(e) { console.error(e); }
})();

})();
